import { createZodDto } from "nestjs-zod/dto";
import { z } from "nestjs-zod/z";
import { InterviewTypeEnum } from "./create-interview.dto";

export const InterviewStatusEnum = z.enum([
  "SETUP",
  "IN_PROGRESS",
  "COMPLETED",
  "ABANDONED",
  "ASSESSING",
  "ASSESSED",
]);

export const MockInterviewSchema = z.object({
  id: z.string().cuid(),
  userId: z.string().cuid(),
  resumeId: z.string().cuid().nullable(),
  jobDescription: z.string(),
  jobTitle: z.string().nullable(),
  companyName: z.string().nullable(),
  engineVersion: z.number().int().default(1),
  interviewType: InterviewTypeEnum,
  questionCount: z.number(),
  status: InterviewStatusEnum,
  blueprint: z.any().nullable().optional(),
  runtimeState: z.any().nullable().optional(),
  turns: z.array(z.any()).optional(),
  messages: z.array(z.any()),
  messageCount: z.number(),
  assessment: z.any().nullable(),
  overallScore: z.number().nullable(),
  completionReason: z.string().nullable().optional(),
  preparedAt: z.string().datetime().nullable().optional(),
  lastError: z.any().nullable().optional(),
  startedAt: z.string().datetime().nullable(),
  completedAt: z.string().datetime().nullable(),
  duration: z.number().nullable(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});

export class MockInterviewDto extends createZodDto(MockInterviewSchema) {}
